import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Switch } from 'antd';
import { BackBtn } from '@comm/BackBtn';

const FormItem = Form.Item;
const { TextArea } = Input;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultAutogrowChecked: true,
      defaultRecordHistoryChecked: true,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataInfo !== this.props.dataInfo) {
      const defaultAutogrowChecked = nextProps.dataInfo.autogrow === 1;
      const defaultRecordHistoryChecked = nextProps.dataInfo.recordHistory === 1;
      this.setState({
        defaultAutogrowChecked,
        defaultRecordHistoryChecked,
      });
    }
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.autogrow = values.autogrow ? 1 : 0;
        values.recordHistory = values.recordHistory ? 1 : 0;
        handSubmit(values);
      }
    });
  };

  handleAutogrowChange = checked => {
    this.props.form.setFieldsValue({
      autogrow: checked === true ? 1 : 0,
    });
  };

  handleRecordHistoryChange = checked => {
    this.props.form.setFieldsValue({
      recordHistory: checked === true ? 1 : 0,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { dataInfo } = this.props;
    const { defaultAutogrowChecked, defaultRecordHistoryChecked } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const ItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button type="primary" style={{ marginRight: 10 }} htmlType="submit">
            确认
          </Button>
        </div>
        <Card>
          <Row>
            <Col span={10}>
              <FormItem label="流水号标识" {...ItemLayout}>
                {getFieldDecorator(`uuid`, {
                  rules: [
                    {
                      required: true,
                      message: '流水号标识',
                    },
                  ],
                  initialValue: dataInfo.uuid,
                })(<Input disabled={!!dataInfo.uuid} placeholder="流水号标识" type="text" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="流水号名称" {...ItemLayout}>
                {getFieldDecorator('label', {
                  initialValue: dataInfo.label,
                })(<Input placeholder="流水号名称" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="流水号模式" {...ItemLayout}>
                {getFieldDecorator('patten', {
                  initialValue: dataInfo.patten,
                })(<Input placeholder="流水号模式" />)}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="当前编号" {...ItemLayout}>
                {getFieldDecorator('currentNumber', {
                  initialValue: dataInfo.currentNumber,
                })(<Input placeholder="当前编号" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="自动增涨" {...ItemLayout}>
                {getFieldDecorator('autogrow', {
                  initialValue: dataInfo.autogrow || 1,
                })(
                  <Switch
                    key={defaultAutogrowChecked}
                    defaultChecked={defaultAutogrowChecked}
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    onChange={this.handleAutogrowChange}
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="记录历史" {...ItemLayout}>
                {getFieldDecorator('recordHistory', { initialValue: dataInfo.recordHistory || 1 })(
                  <Switch
                    key={defaultRecordHistoryChecked}
                    defaultChecked={defaultRecordHistoryChecked}
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                    onChange={this.handleRecordHistoryChange}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="增涨步长" {...ItemLayout}>
                {getFieldDecorator('step', {
                  initialValue: dataInfo.step,
                })(<Input placeholder="增涨步长" type="number" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="配置项描述" {...ItemLayout2}>
                {getFieldDecorator('desc', {
                  initialValue: dataInfo.desc,
                })(<TextArea placeholder="配置项描述" type="textarea" rows={4} />)}
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create()(BaseForm);



// WEBPACK FOOTER //
// ./src/components/boss/serialNumber/FormBase.js